import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dashboard_card_icon_menu_geom",
  "use": "dashboard_card_icon_menu_geom-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"dashboard_card_icon_menu_geom\"><g fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#2D2C34\"><path d=\"M11.533 8.467H1.8V18.2h9.733V8.466ZM0 6.667V20h13.333V6.667H0Z\" /><path d=\"M13.333 13.652a6.008 6.008 0 0 1-1.8.064v1.81a7.778 7.778 0 1 0-7.059-7.059h1.81a6.043 6.043 0 0 1 .064-1.8A5.98 5.98 0 0 1 18.2 7.777a5.98 5.98 0 0 1-4.867 5.875Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol